import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainerStyled } from './mapStyles';
import 'leaflet-polylinedecorator';
import { useIonViewDidEnter } from '@ionic/react';
import { AONB_Bounds } from '../../application/config';
import LocationMarker from '../Mapping/LocationMarker';
import { Trail } from '../../models/Trail';
import SingleTrailMarker from '../Mapping/SingleTrailMarker';
import SingleTrailMapController from '../Mapping/SingleTrailMapController';

type MapProps = {
	trail: Trail;
};

function SingleTrailMap({ trail }: MapProps): ReactElement {
	useIonViewDidEnter(() => {
		window.dispatchEvent(new Event('resize'));
	});
	return (
		<>
			<MapContainerStyled
				id="globalMap"
				className="fullMap"
				center={AONB_Bounds.getCenter()}
				attributionControl={false}
				zoom={14}
				dragging={false}
				zoomControl={false}
				doubleClickZoom={false}
				scrollWheelZoom={false}>
				<>
					<SingleTrailMapController trail={trail} />
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					<LocationMarker />
					<SingleTrailMarker key={`place-trails`} trail={trail} />
				</>
			</MapContainerStyled>
		</>
	);
}

export default SingleTrailMap;
